import { IStackStyles } from "@fluentui/react";
import { DrawerTitleProps } from "./DrawerHeaderTitle";

export const mediaStyles = (): IStackStyles => {
    return {
        root: {
            paddingRight: "16px"
        }
    };
};

export const titleStyles = (): IStackStyles => {
    return {
        root: {
            overflow: "hidden"
        }
    };
};

export const leftAlignmentStyles = (title: DrawerTitleProps): IStackStyles => {
    if (title.kind === "text" && title.nowrap !== undefined && !title.nowrap) {
        return {
            root: {
                textAlign: "left"
            }
        };
    }

    return {};
};
